module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-411.1e70fc06.jpg";